<script>
import { mapActions } from 'vuex';
import ConfirmableButton from "@/driver/components/ConfirmableButton.vue";

export default {
  name: "RecycleDisposalMethodShowModal",
  components: {
    ConfirmableButton
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => null,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      form: null,
    }
  },
  watch: {
    enableDialog (newValue) {
      this.form = null;
      if (newValue) {
        this.fetch();
      }
    },
  },
  methods: {
    ...mapActions("DriverMasterRecycleDisposalMethod", {
      fetchShow: "show",
      destroy: "destroy",
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('close');
    },
    /**
     * 編集ボタン クリックイベント
     */
    editButtonClickEvent () {
      this.$emit('edit');
    },
    /**
     * 削除確認モーダル ネガティブコールバック
     */
    removeNegativeCallback () {},
    /**
     * 削除確認モーダル ポジティブコールバック
     */
    removePositiveCallback () {
      this.destroy({ id: this.targetId }).then(() => {
        this.$emit("register")
      })
    },
    /**
     * 表示データ詳細取得・展開
     */
    fetch () {
      this.fetchShow({ id: this.targetId }).then((content) => {
        console.log(content)
        this.form = content;
      })
    }
  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="enableDialog"
      width="700"
      persistent
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <validation-observer ref="formValidation">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              処分方法詳細
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <template v-if="form">
            <v-card-text class="pt-2">
              <!-- コード・非表示にする -->
              <v-row>
                <v-col cols="6">
                  <div class="overline">
                    コード
                  </div>
                  <h4>{{ form.code }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    v-model="form.invisible"
                    class="float-end"
                    disabled
                    label="非表示にする"
                  />
                </v-col>
              </v-row>
              <!-- /コード・非表示にする -->

              <!-- 処分方法名 -->
              <v-row>
                <v-col cols="12">
                  <div class="overline">
                    処分方法名
                  </div>
                  <h4>{{ form.name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /処分方法名 -->
            </v-card-text>  

            <v-card-title class="primary--text">処理方法</v-card-title>

            <v-card-text>
              <!-- 処分１・処分２ -->
              <v-row>
                <v-col cols="6">
                  <div class="overline">
                    処分１
                  </div>
                  <h4>{{ form.after_disposal_method_1_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>

                <v-col cols="6">
                  <div class="overline">
                    処分２
                  </div>
                  <h4>{{ form.after_disposal_method_2_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /処分１・処分２ -->

              <!-- 処分３・処分４ -->
              <v-row>
                <v-col cols="6">
                  <div class="overline">
                    処分３
                  </div>
                  <h4>{{ form.after_disposal_method_3_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>

                <v-col cols="6">
                  <div class="overline">
                    処分４
                  </div>
                  <h4>{{ form.after_disposal_method_4_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /処分３・処分４ -->

              <!-- 主たる処分方法の指定 -->
              <v-row>
                <v-col cols="12">
                  <div class="overline">
                    主たる処分方法の指定
                  </div>
                  <h4>{{ form.primary_after_disposal_method_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /主たる処分方法の指定 -->

              <!-- 表示順 -->
              <v-row>
                <v-col cols="6">
                  <div class="overline">
                    表示順
                  </div>
                  <h4>{{ form.sort_priority }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <!-- /表示順 -->
            </v-card-text>
          </template>
          <v-divider />
          <v-card-actions>
            <confirmable-button
              caption="削除"
              color="error"
              modal-content="削除します。よろしいですか？"
              modal-positive-color="error"
              @negative="removeNegativeCallback"
              @positive="removePositiveCallback"
            />
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>